export const GOOGLE_DECK_LAYER_ORDER = {
  geographies: 10,
  outlines: 20,
  parcels: 30,
  parcelSelection: 40,
  listings: 60,
} as const
